import { useNavigate } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useCreateOutsourceApInstallmentPlanTemplate } from "../api/queries";
import { InstallmentPlanTemplateForm } from "../ui/InstallmentPlanTemplateForm";

export function OutsourceApInstallmentPlanTemplateCreatePage() {
  const nav = useNavigate({
    from: "/app/performance/settings/outsource-ap-installment-plans/create",
  });
  const createTemplate = useCreateOutsourceApInstallmentPlanTemplate();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            {
              label: "ແມ່ແບບງວດ AP",
              to: "/app/performance/settings/outsource-ap-installment-plans",
            },
            { label: "ເພີ່ມໃໝ່" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">ເພີ່ມແມ່ແບບງວດ AP</h2>
        </div>
        <div className="rounded-xl border bg-card px-6">
          <InstallmentPlanTemplateForm
            onSubmit={async (vals) => {
              await createTemplate.mutateAsync(vals);
              nav({
                to: "/app/performance/settings/outsource-ap-installment-plans",
              });
            }}
            submitting={createTemplate.isPending}
          />
        </div>
      </Main>
    </>
  );
}
